import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { createApiClient } from '../../../apiClient';
import type { VerifyOTPParams } from '../verifyOTP';

export const verifyOTPForUserSignIn = async (
  { otpVerification, verificationToken }: VerifyOTPParams,
  client: DynamicClient
) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const verifyRequest = {
    verificationToken,
    verificationUUID: otpVerification.verificationUUID,
  };

  if (otpVerification.email) {
    return apiClient.signInWithEmailVerification({
      emailVerificationVerifyRequest: verifyRequest,
      environmentId: core.environmentId,
    });
  }

  return apiClient.signInWithSmsVerification({
    environmentId: core.environmentId,
    smsVerificationVerifyRequest: verifyRequest,
  });
};
